import CustomScrollbar from "./custom-scrollbar";
import { customFadeInTopElem, initTextAnimations } from "./animations";
import { initTypedText } from "./typeWriter";

window.mobileAndTabletCheck = () => {
	let check = false;
	(function (a) {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
				a,
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
				a.substr(0, 4),
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};

// INIT SCROLLBAR

const initScrollBar = () => {
	window.customScrollbarInstance = null;

	const scrollBarElem = document.querySelector("#custom-scrollbar");
	const scrollBarOptions = {
		damping: window.mobileAndTabletCheck() ? 0.1 : 0.05,
		delegateTo: document,
	};

	if (scrollBarElem) {
		window.customScrollbarInstance = new CustomScrollbar(
			scrollBarElem,
			scrollBarOptions,
		);
	}
};

initScrollBar();

// FIX PARA 100VH MOBILE
const setVH = () => {
	// css
	// height: 100vh;
	// height: calc(var(--vh, 1vh) * 100);
	// the variable is defined
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
	window.addEventListener("resize", function () {
		let vhResize = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vhResize}px`);
	});
};

// HEADER CHANGE
const headerChange = (scrolled_) => {
	const scrollLimit = 100;
	const fixLimit = 150;

	if (scrolled_ >= scrollLimit && scrolled_ < fixLimit) {
		document.body.classList.add("header-scrolled");
	} else if (scrolled_ >= fixLimit) {
		document.body.classList.add("header-fixed");
	} else {
		document.body.classList.remove("header-scrolled", "header-fixed");
	}
};

const initHeaderAnimations = () => {
	const header = document.querySelector("header.header-theme");
	if (!header) return false;

	const logo = header.querySelector(".logo");
	if (logo) {
		customFadeInTopElem({
			elem: logo,
			parentElem: header,
			delay: 0.5,
		});
	}

	const menuBtn = document.querySelector(".menu-btn");
	if (menuBtn) {
		customFadeInTopElem({
			elem: menuBtn,
			parentElem: header,
			delay: 0.75,
		});
	}

	const menuItems = header.querySelectorAll("nav ul li");
	if (menuItems) {
		customFadeInTopElem({
			elem: menuItems,
			parentElem: header,
			delay: 0.75,
		});
	}
};

// SINGLE
const singleGoNextHandler = () => {
	const section = document.querySelector("section.single-hero");
	if (!section) return false;
	const thisGoNextBtn = section.querySelector(".go-next-btn");
	thisGoNextBtn?.addEventListener("click", () => {
		if (section.nextElementSibling)
			window.customScrollbarInstance?.scrollbarInstance?.scrollIntoView(
				section.nextElementSibling,
			);
	});
};

// SCROLL DIRECTION
let lastScrollTop = 0;
const detectScrollDirection = (lastScrollTop_) => {
	const st = window.customScrollbarInstance?.scrollbarInstance.scrollTop;
	if (st === 0) {
		document.documentElement.setAttribute("data-scroll-dir", "down");
	} else if (st < lastScrollTop_) {
		document.documentElement.setAttribute("data-scroll-dir", "up");
	} else {
		document.documentElement.setAttribute("data-scroll-dir", "down");
	}
	lastScrollTop = st;
};

// MENU BTN
const openMenu = () => {
	const menu = document.querySelector(".header-theme__col--menu");
	if (menu) {
		menu.classList.add("show");
		window.customScrollbarInstance.scrollbarInstance?.updatePluginOptions(
			"disableScroll",
			{
				disable: true,
			},
		);
	}
};
const closeMenu = () => {
	const menu = document.querySelector(".header-theme__col--menu");
	if (menu) {
		menu.classList.remove("show");
		window.customScrollbarInstance.scrollbarInstance?.updatePluginOptions(
			"disableScroll",
			{
				disable: false,
			},
		);
	}
};

const menuBtnHandler = () => {
	const menuBtn = document.querySelector(".menu-btn");
	menuBtn?.addEventListener("click", () => {
		if (menuBtn.classList.contains("menu-active")) {
			closeMenu();
		} else {
			openMenu();
		}
		menuBtn.classList.toggle("menu-active");
	});
};

window.customScrollbarInstance.scrollbarInstance?.addListener((status) => {
	const offset = status.offset;
	headerChange(offset.y);
	detectScrollDirection(lastScrollTop);

	initTypedText();
});

const allScriptsGlobal = () => {
	setVH();
	menuBtnHandler();
	singleGoNextHandler();

	initHeaderAnimations();

	const animatedBlocks = document.querySelectorAll(
		'section[class^="wp-block-theme-blocks"] .animated-block:not(.animated-block__not-auto), section[class*="wp-block-theme-blocks"] .animated-block:not(.animated-block__not-auto)',
	);
	initTextAnimations({ blocks: animatedBlocks });

	initTypedText();

	window.customScrollbarInstance.markersUpdate();
};

window.addEventListener("load", () => {
	// console.log("SCRIPTS GLOBAL LOAD");
	allScriptsGlobal();

	window.addEventListener(
		"change-page",
		() => {
			// console.log("SCRIPTS GLOBAL CHANGE PAGE");
			allScriptsGlobal();
		},
		true,
	);
});
